<script lang="ts" setup>
import { QBtn } from "quasar";
import { ref } from "vue";
import MButton from "../MButton";
import MLayoutStack from "./../MLayoutStack";
import MMenu from "../MMenu";
import { randomID } from "../../../utils/helpers";

defineProps({
  label: {
    type: String,
    default: "Filters",
  },
  border: Boolean,
  outline: Boolean,
  ghost: Boolean,
  icon: String,
  color: {
    type: String,
    default: "secondary",
  },
  loading: Boolean,
  filterCount: [Number, Boolean],
  hasFilter: Boolean,
  borderless: Boolean,

  dense: Boolean,
});

const buttonRef = ref<InstanceType<typeof MButton>>();
const menuRef = ref<InstanceType<typeof MMenu>>();
const menuOpen = ref<boolean>(false);

function closeMenu() {
  menuRef.value?.hide();
}

function toggleMenu() {
  menuOpen.value = !menuOpen.value;
}
const id = randomID();
</script>
<template>
  <div>
    <m-button
      :id="`${id}-filter-toggle-button`"
      ref="buttonRef"
      :class="['m-filter-button', dense && 'dense']"
      :border="border"
      :outline="outline"
      :ghost="ghost"
      :icon="icon"
      :color="color"
      :loading="loading"
      :borderless="borderless"
      :aria-expanded="menuOpen"
      aria-haspopup="dialog"
      aria-controls="filter-panel"
      @click="toggleMenu"
    >
      <m-layout-stack class="filter-label items-center" horizontal gap="1">
        <!-- <q-icon class="filter-button--icon" name="fa-solid fa-bars-filter" /> -->
        <i
          v-if="filterCount || hasFilter"
          class="filter-button--icon fa-solid fa-filter"
          aria-hidden="true"
        />
        <i v-else class="filter-button--icon fa-solid fa-bars-filter" aria-hidden="true"></i>

        <span v-if="label">{{ label }} </span>
        <div v-if="filterCount || hasFilter" class="filter-count">
          <!-- <span>{{ filterCount }}</span> -->
        </div>
      </m-layout-stack>
    </m-button>
    <m-menu
      ref="menuRef"
      v-model="menuOpen"
      :target="buttonRef"
      class="filter-button-content"
      :aria-labelledby="`${id}-filter-toggle-button`"
      no-auto-open
    >
      <q-btn
        flat
        dense
        class="cursor-pointer medicus-outline filter-close-button bg-white"
        icon="fa-light fa-xmark"
        aria-label="Close filters"
        @click="closeMenu"
      />
      <div>
        <slot />
      </div>
    </m-menu>
  </div>
</template>

<style lang="scss">
.m-filter-button {
  // height: auto !important;
  position: relative;

  &.dense {
    height: auto !important;
    > .medicus-button {
      padding: 0 !important;
    }
  }

  .filter-label {
    color: var(--grey-darkest);
  }

  .filter-count {
    width: 5px;
    height: 5px;

    font-size: 12px;
    line-height: 16px;

    display: flex;

    align-items: center;
    justify-content: center;
    align-self: flex-start;

    margin-top: 3px;

    border-radius: 99px;
    background: var(--status-green);

    span {
      color: white;
    }
  }
}

.filter-button-content {
  min-width: 500px;
  max-width: 700px;
  padding: 1rem 1.5rem;

  .filter-close-button {
    position: absolute;
    z-index: 100;
    top: 0.5rem;
    right: 0.5rem;
  }

  .task-filter {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gap-3);
    flex-direction: column;
  }

  /* md and up */
  @media (max-width: 505px) {
    min-width: auto;
    max-width: 100%;
    position: fixed;
    top: 1em;
    left: calc(1em + var(--sidebar-width-collapsed));
    //transform: translate(-50%, -50%);
    width: calc(100% - 2em - var(--sidebar-width-collapsed));
    height: calc(100vh - 2em);
    overflow: auto;
    /* stringer for small screens */
    box-shadow: 0 0 2em rgba(0, 2, 0, 0.3);
  }
}
</style>
